import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSideProps } from "next";
import { TFunction } from "next-i18next";
import React from "react";

import { serverSidePage } from "@/utils/serverSide";
import Layout from "@/components/Page/Layout";
import { Website } from "@/types/website";
import { useUser } from "@/hooks/useUser";
import { useRouter } from "next/router";
import Signin from "@/components/Page/Signin";
import { getProviders } from "next-auth/client";
import Event from "@/components/Accreditation/Event";

type Props = {
  website: Website;
  providers: any;
};

export const AccreditationPage = ({
  providers,
  website,
}: Props): React.ReactElement => {
  const [session] = useUser();
  const router = useRouter();
  const { id } = router.query;

  if (session?.user?.id && id)
    return <Event id={id} rounded={false} website={website} />;
  return <Signin providers={providers} eventId={id} />;
};

AccreditationPage.getLayout = function getLayout(
  page: React.ReactElement,
  t: TFunction
) {
  const { website } = page.props;

  return (
    <Layout title={t("website.accreditations")} website={website}>
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
  req,
}) => ({
  props: {
    providers: await getProviders(),
    ...(await serverSidePage(query, req, false, "accreditations")),
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default AccreditationPage;
